/* eslint-env browser */
import $ from 'jquery';

// Expose globals for backwards compatibility with non-bundled code
window.jQuery = $;
